import { UserInfo } from './user-Info.model';

export class UserDetail {
  id: string;
  earnings: number;
  balance: number;
  userInfo: UserInfo;
  billingInfo: UserInfo;
  hwInfo: any;
  stripeInfo: any;

  constructor(
    id?: string,
    earnings?: number,
    balance?: number,
    userInfo?: UserInfo,
    billingInfo?: UserInfo
  ) {
    this.id = id || null;
    this.balance = balance || 0;
    this.earnings = earnings || 0;
    this.userInfo = userInfo || new UserInfo();
    this.billingInfo = billingInfo || new UserInfo();
  }
}
